import { createAction, props } from '@ngrx/store';
import { News } from '../../models';
import { PagedOverview } from 'src/app/standalone/models/paged-overview.model';

export const LoadNews = createAction('[News] Load News items');
export const LoadNewsSuccess = createAction('[News] Load News items Success', props<{ News: News[] }>());
export const LoadNewsFail = createAction('[News] Load News items Fail', props<{ error: any }>());

export const LoadNewsOverview = createAction('[News] Load News overview items', props<{ take?: number; skip?: number }>());
export const LoadNewsOverviewSuccess = createAction('[News] Load News overview items Success', props<{ News: PagedOverview<News> }>());
export const LoadNewsOverviewFail = createAction('[News] Load News overview items Fail', props<{ error: any }>());

export const LoadMoreNews = createAction('[News] Load More News');
export const LoadMoreNewsSuccess = createAction('[News] Load More News Success', props<{ News: PagedOverview<News> }>());

export const LoadNewsById = createAction('[News] Load News item by Id', props<{ id: number }>());
export const LoadNewsByIdSuccess = createAction('[News] Load News item by Id Success', props<{ Item: News }>());
export const LoadNewsByIdFail = createAction('[News] Load News item by Id Fail', props<{ id: number; error: any }>());
